import { Box, IconButton, Input } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import classNames from 'classnames';
import { FunctionComponent, useState } from 'react';
import { ArrowRight, Search as SearchIcon } from 'wix-ui-icons-common';

import { DATA_HOOKS } from '../../../dataHooks';

import css from './index.module.scss';

type SearchInputProps = {
  initialSearchTerm?: string;
  retryGenerateAnswer: () => void;
  onSearch: (searchTerm: string) => void;
  hideGradient?: boolean;
};

export const SearchInput: FunctionComponent<SearchInputProps> = ({
  initialSearchTerm,
  retryGenerateAnswer,
  onSearch,
  hideGradient = false,
}) => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState(initialSearchTerm || '');


  const handleSearch = async () => {
    if (!searchTerm.trim()) {
      return;
    }
    if (searchTerm.trim() === initialSearchTerm?.trim()) {
      retryGenerateAnswer();
      return;
    }
    onSearch(searchTerm);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  return (
    <Box className={classNames(css.searchInputWrapper, { [css.hideGradient]: hideGradient })}>
      <Input
        placeholder={t('header.search-bar-modal.placeholder')}
        onChange={handleChange}
        value={searchTerm}
        dataHook={DATA_HOOKS.SEARCH_BAR_INPUT}
        size="large"
        border="round"
        className={css.searchInput}
        onEnterPressed={handleSearch}
        clearButton={true}
        onClear={() => setSearchTerm('')}
        prefix={
          <Input.IconAffix>
            <SearchIcon />
          </Input.IconAffix>
        }
        suffix={
          <Input.IconAffix>
            <IconButton
              size='tiny'
              skin="ai"
              className={css.searchIconBtn}
              onClick={handleSearch}
            >
              <ArrowRight size='small' />
            </IconButton>
          </Input.IconAffix>
        }
      />
    </Box>
  );
};
